import { createQuery } from '@tanstack/solid-query'
import { api, getCurrentUserId } from '~/services/api'
import type { Product } from '~/lib/derive-extra-boxes'

// The user-scoped single-product endpoint is the only one that returns
// `purchase_daily_limit` for the coin/gem extra-box products. Backend
// serializers in this codebase vary between bare and wrapped shapes (see
// recent fixes to `store/products` and `challenge_progresses`), so accept
// both forms.
type UserProductResponse = { product: Product } | Product

export const extraBoxProductQueryKey = ['extra-box-product'] as const

export const useExtraBoxProduct = (productId: () => number) => {
  return createQuery(() => ({
    queryKey: [...extraBoxProductQueryKey, productId()],
    queryFn: async () => {
      const userId = await getCurrentUserId()
      const response = await api.service
        .get(`store/users/${userId}/products/${productId()}`)
        .json<UserProductResponse>()
      return 'product' in response ? response.product : response
    },
    enabled: productId() > 0,
  }))
}
